import { env } from "../environment/utils";
export const MODE_DEV = ['debugger', 'develop'];
export const GROUP_ID_DEV_MODE = ['admin'];
export const USER_CONFIG = {
    DURATION_MEETING_MIN_TO_SHOW_FEEDBACK: 'DURATION_MEETING_MIN_TO_SHOW_FEEDBACK',
    ENABLE_SHOW_FEEDBACK: 'ENABLE_SHOW_FEEDBACK'
};
export const MEETING_STATUS = {
    MEETING: 'meeting',
    END: 'end',
    LEAVE: 'leave'
};
export const LOCAL_GUEST_NAME = env("LOCAL_GUEST_NAME");
export const DURATION_MEETING_MIN_TO_SHOW_FEEDBACK = env("DURATION_MEETING_MIN_TO_SHOW_FEEDBACK") || 0;
export const ENABLE_SHOW_FEEDBACK = env("ENABLE_SHOW_FEEDBACK") || true;
